import Loader from '@app/shared/loader'

const BackgroundChangeLoader = () => <Loader position="absolute" opacity="0.6" width="100%" height="100%" zIndex="1" />

export default BackgroundChangeLoader
